import { FC } from 'react';

interface IGeneratingIconProps {
  stroke?: string;
}

const ArrowIcon: FC<IGeneratingIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.791341 4.44026C1.03417 4.66574 1.41381 4.65168 1.63929 4.40886L3.19961 2.72851L3.19961 9.60059C3.19961 9.93196 3.46824 10.2006 3.79961 10.2006C4.13098 10.2006 4.39961 9.93196 4.39961 9.60059V2.72851L5.95994 4.40886C6.18542 4.65168 6.56506 4.66574 6.80788 4.44026C7.05071 4.21478 7.06477 3.83514 6.83929 3.59232L4.23929 0.792315C4.12576 0.670055 3.96645 0.600586 3.79961 0.600586C3.63277 0.600586 3.47346 0.670055 3.35994 0.792315L0.759936 3.59232C0.534454 3.83514 0.548515 4.21478 0.791341 4.44026Z"
        fill={stroke ?? '#D0D5DD'}
      />
    </svg>
  );
};

export default ArrowIcon;
